import axios from 'axios';
export const state = () => ({
  currentItem: {},
  menuStructure: [],
  menuItems: [],
  myMenuStructure: [],
  myMenuItems: [],
  categoryFieldMappings: {} // Cache of NetSuite field mappings { categoryId: fields[] }
})

export const mutations = {
  setMenuStructure(state, menuStructure) {
    state.menuStructure = menuStructure
  },
  setMenuItems(state, menuItems) {
    state.menuItems = menuItems
  },
  setMyMenuStructure(state, menuStructure) {
    state.myMenuStructure = menuStructure
  },
  setMyMenuItems(state, menuItems) {
    state.myMenuItems = menuItems
  },
  setCurrentItem(state, menuItem) {
    state.currentItem = menuItem
  },
  setBreadcrumb(state, breadcrumb) {
    state.breadcrumbs.push(breadcrumb)
  },
  removeBreadcrumb(state, id) {
    state.breadcrumbs.filter(item => item.id !== id)
  },
  setCategoryFieldMappings(state, mappings) {
    state.categoryFieldMappings = mappings
  }
}

export const actions = {
  async getMenuStructure({ commit }) {
    try {
      await axios
          .get('/api/my-smi-menu-items?list_all=false&type=all')
          .then(res => {
            // type=all returns { tree, fieldMappings }
            var data = res.data
            if (data && data.tree) {
              commit('setMenuStructure', data.tree)
              if (data.fieldMappings) {
                commit('setCategoryFieldMappings', data.fieldMappings)
              }
            } else {
              // Fallback for backward compatibility
              commit('setMenuStructure', data)
            }
          })
    } catch (e) {
      console.log(e)
    }
  },
  async getMyMenuItems({ commit }) {
    try {
      await axios
          .get('/api/my-smi-menu-items?list_all=true&type=my')
          .then(res => {
            commit('setMyMenuItems', res.data)
          })
    } catch (e) {
      console.log(e)
    }
  },
  async getMyMenuStructure({ commit }) {
    try {
      await axios
          .get('/api/my-smi-menu-items?list_all=false&type=my')
          .then(res => {
            commit('setMyMenuStructure', res.data)
          })
    } catch (e) {
      console.log(e)
    }
  },
  async getMenuItems({ commit }) {
    try {
      await axios
          .get('/api/my-smi-menu-items?list_all=true&type=full')
          .then(res => {
            commit('setMenuItems', res.data)
          })
    } catch (e) {
      console.log(e)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async findMenuItem({ commit }, id) {
    try {
      const result = await axios
          .get(`/api/my-smi-menu-items/${id}`)
          .then(res => {
            return res.data
          })
      commit('setCurrentItem', result)
    } catch (e) {
      console.log(e)
    }
  }
}

export const getters = {
  rootMenuItems: state => state.menuStructure,
  // rootMenuItems: state => {
  //   return state.menuStructure.filter(item => item.parent.present === false)
  // },
  allMenuItems: state => state.menuItems,
  getCurrentItem: state => state.currentItem,
  rootMyMenuItems: state => state.myMenuStructure,
  allMyMenuItems: state => state.myMenuItems,
  categoryFieldMappings: state => state.categoryFieldMappings
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};